import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Input } from 'antd';
import { IconButton } from 'src/components/design-system/buttons';
import { usePandaComposer } from 'shared/panda/chat/panda-composer.hooks';
import { MAX_MESSAGE_LENGTH } from 'shared/panda/panda-chat.schemas';
import styles from './render-user-input.module.scss';
import { SendIcon } from 'src/images';
import { usePandaConversation } from '../../panda-chat-provider';

const { TextArea } = Input;

export function RenderUserInput() {
  const { loading, lang } = usePandaConversation();
  const { handleChange, handleBlur, handleSubmit, values, canSend } = usePandaComposer();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && e.shiftKey) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      if (loading) return;
      handleSubmit();
    }
  };

  return (
    <form className={styles.root} onSubmit={handleSubmit}>
      <div className={styles.userInput}>
        <TextArea
          className={styles.input}
          variant="borderless"
          placeholder={lang.PANDA_INPUT_PLACEHOLDER || 'Ask Panda'}
          name="message"
          value={values.message}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={MAX_MESSAGE_LENGTH}
          autoSize={{ minRows: 1, maxRows: 4 }}
          onKeyDown={handleKeyDown}
        />
        <IconButton
          className={styles.sendBtn}
          disabled={!canSend}
          type="submit"
          label={lang.SEND_MESSAGE || 'Send message'}
          tooltipProps={{ placement: 'top' }}>
          <SendIcon className={styles.sendIcon} />
        </IconButton>
      </div>
      <ReactMarkdown className={styles.disclaimer}>{lang.DISCLAIMER ?? ''}</ReactMarkdown>
    </form>
  );
}
